import React from 'react';
import BaseScanHeader from './BaseScanHeader';

export type YearScanHeaderOwnProps = {
    yearScanValue: number;
    setYearScanValue: (year: number) => void;
};

export type YearScanHeaderProps = YearScanHeaderOwnProps;

const YearScanHeader: React.FC<YearScanHeaderProps> = (props) => {
    return (
        <BaseScanHeader
            display={props.yearScanValue.toString()}
            onPreviousPress={() => props.setYearScanValue(props.yearScanValue - 1)}
            onNextPress={() => props.setYearScanValue(props.yearScanValue + 1)}
        />
    );
};

export default React.memo(YearScanHeader);
